// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
//console.log('Vite ⚡️ Rails')
//alert('test!')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

//console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
import React from "react"
import 'bootstrap'
import { createRoot } from "react-dom/client";
import { AdminJobRouter } from "../components/AdminJobRouter";
import { AdminApplicantRouter } from "../components/AdminApplicantRouter";
import { AdminInformationRouter } from "../components/AdminInformationRouter";

// 管理側の求人画面
const job = document.getElementById("job");
if (job) {
  document.addEventListener("DOMContentLoaded", () => {
    createRoot(job).render(<AdminJobRouter />);
  });
}

// 管理側の応募者画面
const applicant = document.getElementById("applicant");
if (applicant) {
  document.addEventListener("DOMContentLoaded", () => {
    createRoot(applicant).render(<AdminApplicantRouter />);
  });
}

// 管理側のお知らせ画面
const information = document.getElementById("information");
if (information) {
  document.addEventListener("DOMContentLoaded", () => {
    createRoot(information).render(<AdminInformationRouter />);
  });
}

